import React from 'react';

// Module-level thresholds — updated when Topics component loads settings
export let _thRed = 0.4, _thGreen = 0.7;

export function setThresholds(red, green) {
  _thRed = red;
  _thGreen = green;
}

export function confColor(c) {
  if (c===null||c===undefined) return 'var(--muted)';
  if (c<_thRed) return 'var(--red)';
  if (c<_thGreen) return 'var(--amber)';
  return 'var(--green)';
}

export function Badge({ c, status }) {
  if (c===null&&!status) return <span className="badge badge-none">Not started</span>;
  if (c===null) return <span className="badge badge-amber">In progress</span>;
  if (c<_thRed) return <span className="badge badge-red">Needs work</span>;
  if (c<_thGreen) return <span className="badge badge-amber">Moderate</span>;
  return <span className="badge badge-green">Strong</span>;
}
